import { jsx, Fragment } from "react/jsx-runtime";
import { BulkRowActionsProvider } from "./useBulkRowActionsContext.js";
import { BulkRowSelectionProvider } from "./useBulkRowSelection.js";
import { TableScrollerProvider } from "./useTableScroller.js";
import { I18nextProvider } from "react-i18next";
import { ColumnSelectionProvider } from "./useColumnSelectionContext.js";
const OptionalI18nProvider = ({ i18n, children }) => {
  if (i18n) {
    return /* @__PURE__ */ jsx(I18nextProvider, { i18n, children });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
};
const TableProviders = (props) => {
  const key = props.tableId ?? "";
  return /* @__PURE__ */ jsx(OptionalI18nProvider, { i18n: props.i18n, children: /* @__PURE__ */ jsx(TableScrollerProvider, { children: /* @__PURE__ */ jsx(ColumnSelectionProvider, { children: /* @__PURE__ */ jsx(BulkRowSelectionProvider, { children: /* @__PURE__ */ jsx(BulkRowActionsProvider, { children: props.children }, key) }, key) }, key) }) });
};
export {
  TableProviders
};
